module.exports = __webpack_public_path__ + "img/status.412cb39a.svg";